import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {BillingPartyMember} from '../../../graphql/billing_party.datatypes';
import {gqlPaginatorInfo, PaginatiorInfo} from '../../../graphql/common.datatypes';

interface BillingPartyMembersData {
    billingPartyMembers: {
        data: BillingPartyMember[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const GET_BILLING_PARTY_MEMBERS_QUERY = gql`
  query billingPartyMembers($count: Int!, $page: Int!, $where: WhereConditions, $orderBy: [OrderByClause!]){
    billingPartyMembers(first: $count, page: $page, where: $where, orderBy: $orderBy){
      data {
        id
        billing_party_id
        user_id
        first_name
        last_name
        email

        group {
            id
            name

            tour {
                id
                internal_name
                display_name
            }
        }
      }
      ${gqlPaginatorInfo}
    }
  }
`;

export const getBillingPartyMembers = (count: number, page: number, where?: any, orderBy?: any) => useQuery<BillingPartyMembersData>(
    GET_BILLING_PARTY_MEMBERS_QUERY,
    {
        variables: {
            count,
            page,
            where,
            orderBy,
        },
    }
);

export default getBillingPartyMembers;
